// Résumé des tâches sur la carte (PER-2446, PER-2447) : une barre de segments,
// un par tâche dans l'ordre, et une seule tâche détaillée en dessous.
// Fonctions pures, testées avec Jest.

export const nbTachesFaites = (taches = []) => taches.filter((t) => t.isDone).length;

// Première tâche à faire, -1 quand tout est fait (ou sans tâche).
export const indexProchaineTache = (taches = []) => taches.findIndex((t) => !t.isDone);

const estIndexValide = (taches, i) => Number.isInteger(i) && i >= 0 && i < taches.length;

// Tâche détaillée sous la barre : celle que la souris survole, sinon celle
// épinglée par un clic, sinon la prochaine à faire. -1 s'il n'y a rien à montrer.
export function indexTacheAffichee(taches = [], { survolee = null, epinglee = null } = {}) {
  if (estIndexValide(taches, survolee)) return survolee;
  if (estIndexValide(taches, epinglee)) return epinglee;
  return indexProchaineTache(taches);
}

// Un clic sur un segment épingle sa tâche ; un second clic sur le même la
// désépingle (retour à la prochaine tâche).
export const basculerEpingle = (epinglee, index) => (epinglee === index ? null : index);

// Nom accessible d'un segment.
export function libelleSegment(tache, index, total) {
  return `Tâche ${index + 1} sur ${total} : ${tache.name}${tache.isDone ? " (faite)" : ""}`;
}
